import React, {useEffect, useState} from 'react'
import { useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import axios from 'axios';
import PropTypes from 'prop-types';
import ActionDialogStudent from './ActionDialogStudent';


function ShowStudent (props)  {
  const endpoint = 'http://127.0.0.1:8000/api';
  const [course, setCourse] = useState([]);
  const [parent, setParent] = useState([]);

  const listStudent = useSelector(state => state.student);
    const [rowDataState, setRowDataState] = useState([]);
    const [statusButton, setStatusButton] = React.useState(false);

      const [tableColumns, setTableColumns] = useState([]);
      const [tableList, setTableList] = useState([]);
      
      const columns = [
        {
          name: 'id',
          options: {
            filter: false,
            display: false,
          }
        },
        {
          label: 'Nombre',
          name: 'name',
          options: {
            filter: true,
          }
        },
        {
          label: 'Apellido',
          name: 'lastName',
          options: {
            filter: true,
          }
        },
        {
          label: 'Cédula',
          name: 'nit',
          options: {
            filter: true,
          }
        },
        {
          label: 'Descripción',
          name: 'description',
          options: {
            display:false,
            filter: false,
          }
        },
        {
          label: 'Fecha de Nacimineto',
          name: 'birthday',
          options: {
            display:false,
            filter: false,
            }
        },
        {
          label: 'Responsable',
          name: 'representative_id',
          options: {
            filter: true,
            display: false,
            customBodyRender: (value) => {
              const item = value;
              let nameItem = '';
              parent.map((option) => {
                if (option.id === item) {
                  nameItem = option.name +" "+option.lastName;
                }
                return nameItem;
              });
              return nameItem;
            },
          }
        },
        {
          name: 'representative_id',
          options: {
            filter: true,
            display: false,
          }
        },
        {
          label: 'Curso',
          name: 'course_id',
          options: {
            filter: true,
            customBodyRender: (value) => {
              const cour = value;
              let nameCourse = '';
              course.map((option) => {
                if (option.id === cour) {
                  nameCourse = option.name;
                  console.log(nameCourse);
                }
                return nameCourse;
              });
              return nameCourse;
            },
          }
        },
        {
          name: 'course_id',
          options: {
            filter: true,
            display: false,
          }
        },
        {
            label: 'Estado',
            name: 'status',
            options: {
              filter: true,
              display: false,
              customBodyRender: (value) => {
                if(value === 'Pending'){
                  return 'Pendiente';
                }else if(value === 'Active'){
                  return 'Activo';
                }
                  return 'Removido';
                }
              }
          },
      ];

     /**
 * Method to set the documents list and tabe columns
 */
  useEffect(() => {
    if (listStudent && listStudent.length >= 0) {
      setTableList(listStudent);
      if (tableColumns.length === 0 && parent.length !== 0  && parent.length !== undefined
        && course.length !== 0  && course.length !== undefined)  {
        setTableColumns(columns);
      }
    }
  }, [listStudent, parent, course]);
 
   /**
  * Method to set the list pricing plans
  */
   const getAllActiveParent = async() => {
    const response = await axios.get(endpoint+'/parents');
    setParent(response.data);
  };

     /**
  * Method to set the list pricing plans
  */
  const getAllActiveCourse = async() => {
    const response = await axios.get(endpoint+'/courses');
    setCourse(response.data);
  };

  /**
   * Retrieve pricing plan list
   */
  useEffect(() => {
    getAllActiveParent(); 
    getAllActiveCourse(); 
  }, []);
  
  
      /**
       * Method to recoer the specifid values of the row
       * @param {rowData} rowData
       */
      const handleRowData = (rowData) => {
        const rowDataTemp = [];
        rowDataTemp.length = 0;
        rowDataTemp.push(rowData[0]);
        rowDataTemp.push(rowData[1]);
        rowDataTemp.push(rowData[2]);
        rowDataTemp.push(rowData[3]);
        rowDataTemp.push(rowData[4]);
        rowDataTemp.push(rowData[5]);  
        rowDataTemp.push(rowData[6]); 
        rowDataTemp.push(rowData[7]); 
        rowDataTemp.push(rowData[8]);  
        rowDataTemp.push(rowData[9]); 
        rowDataTemp.push(rowData[10]); 
        setRowDataState(rowDataTemp);   
      };
    
      const handleCloseButton = () => {
        setStatusButton(false);
      };
    
      const options = {
        selectableRowsHideCheckboxes: true,
        selectableRows: 'single',
        filterType: 'dropdown',
        responsive: 'standard',
        print: true,
        selectableRowsOnClick: false,
        rowsPerPage: 10,
        downloadOptions: {
          filename: 'lp',
          filterOptions: {
            useDisplayedRowsOnly: true,
          }
        },
        onDownload: (buildHead, buildBody, columnsData, data) => {
          const val = '\uFEFF' + `${buildHead(columnsData)}${buildBody(data)}`.trim();
          return val;
        },
        onRowClick: (rowData) => {          
          handleRowData(rowData);
          setStatusButton(true);
        }
      };
    
      return (
        <div>
        <div>
          <MUIDataTable
            title='Estudiantes'
            data={tableList}
            columns={tableColumns}
            options={options}
          />
          <ActionDialogStudent openStatus={statusButton} onClosed= {handleCloseButton} rowData={rowDataState} parent ={parent} course={course}/>
        </div>
        </div>
      );
}

ShowStudent.propTypes = {
  dataStudent: PropTypes.string,
};

ShowStudent.defaultProps = {
  dataStudent: "true"
};

export default ShowStudent